import React from 'react';

import { SplitCarousel } from '../../components/SplitCarousel/SplitCarousel';
import { useInView } from '../../hooks/useInView';
import type { Outcomes, Step } from './types';

import './OutcomesSection.css';

type OutcomesSectionProps = {
    data: Outcomes;
};

export function OutcomesSection({ data }: OutcomesSectionProps) {
    const [ref, inView] = useInView<HTMLElement>();

    return (
        <section
            ref={ref}
            className={`programs-outcomes faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
        >
            <div className="programs-outcomes__head">
                <span className="programs-eyebrow faves-reveal">{data.eyebrow}</span>
                <h2
                    className="programs-outcomes__heading faves-reveal"
                    style={{ '--reveal-delay': '120ms' } as React.CSSProperties}
                >
                    {data.heading}
                </h2>
            </div>
            <SplitCarousel<Step>
                slides={data.steps}
                classPrefix="programs-outcomes"
                previousLabel="Previous step"
                nextLabel="Next step"
                dotLabel={(i) => `Go to step ${i + 1}`}
                arrowFocusColor="var(--faves-accent)"
                dotColor="var(--faves-accent)"
                renderVisual={(step) => (
                    <img
                        src={step.image}
                        alt=""
                        className="programs-outcomes__visual-img"
                        aria-hidden="true"
                        loading="lazy"
                        decoding="async"
                    />
                )}
                renderText={(step, i) => (
                    <React.Fragment>
                        <span className="programs-outcomes__step faves-eyebrow" key={`step-${i}`}>
                            {step.step}
                        </span>
                        <div className="programs-outcomes__copy" key={`copy-${i}`}>
                            <h3 className="programs-outcomes__step-heading faves-display">{step.heading}</h3>
                            <p className="programs-outcomes__body faves-body">{step.body}</p>
                        </div>
                    </React.Fragment>
                )}
            />
        </section>
    );
}
